<script>
import { mapGetters } from 'vuex';
import {
  iBadge,
  iBadgeColours,
  iSpinner,
  iFeaturedIcon,
} from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';

export default {
  components: {
    iBadge,
    iSpinner,
    iFeaturedIcon,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      iBadgeColours,
      palette,
    };
  },
  computed: {
    ...mapGetters(['getDocumentReviewAgentRunsForCustomerUUID']),
    latestDocumentReviewAgentRun() {
      const runs = this.getDocumentReviewAgentRunsForCustomerUUID(
        this.document.customer_id,
      );
      if (!runs) return null;

      return runs
        .filter((run) => run.document_id === this.document.id)
        .reduce(
          (latest, run) =>
            !latest || new Date(run.started_at) > new Date(latest.started_at)
              ? run
              : latest,
          null,
        );
    },
    isFailed() {
      return this.latestDocumentReviewAgentRun?.status === 'FAILED';
    },
    isRunning() {
      return this.latestDocumentReviewAgentRun?.status === 'RUNNING';
    },
    isFinished() {
      return this.latestDocumentReviewAgentRun?.status === 'FINISHED';
    },
    featuredIconProperties() {
      const properties = {
        symbol: '',
        type: '',
      };
      if (this.isRunning || this.isFailed) {
        properties.symbol = 'medium-user-profile-focus';
        properties.type = 'primary';
      }

      return properties;
    },
    badgeProperties() {
      const properties = {
        label: '',
        colour: '',
        outline: true,
        icon: '',
        hasLeadingIcon: false,
      };
      if (this.isFinished) {
        switch (this.latestDocumentReviewAgentRun?.output?.risk_level) {
          case 'HIGH':
            properties.label = 'High Risk';
            properties.colour = iBadgeColours.ERROR;
            properties.outline = false;
            break;
          case 'MEDIUM':
            properties.label = 'Medium Risk';
            properties.colour = iBadgeColours.WARNING;
            properties.outline = false;
            break;
          case 'LOW':
            properties.label = 'Low Risk';
            properties.colour = iBadgeColours.SUCCESS;
            properties.outline = false;
            break;
          case 'NOT_APPLICABLE':
            properties.label = 'Not Applicable';
            properties.colour = iBadgeColours.NEUTRAL;
            properties.outline = true;
            break;
        }
      } else if (this.isFailed) {
        properties.label = 'Report failed';
        properties.colour = iBadgeColours.ERROR;
        properties.outline = true;
        properties.icon = 'medium-alert-circle';
        properties.hasLeadingIcon = true;
      }

      return properties;
    },
  },
};
</script>
<template>
  <div v-if="isFinished || isFailed">
    <i-badge
      :label="badgeProperties.label"
      :colour="badgeProperties.colour"
      :outline="badgeProperties.outline"
      :aria-label="badgeProperties.label.toLowerCase()"
      :icon="badgeProperties.icon"
      :has-leading-icon="badgeProperties.hasLeadingIcon"
    ></i-badge>
  </div>
  <div v-else-if="isRunning" class="d-flex flex-row align-items-center i-gap-4">
    <i-featured-icon v-bind="featuredIconProperties"></i-featured-icon>
    <i-spinner size="l" type="primary"></i-spinner>
  </div>
</template>

<style lang="scss"></style>
